import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ s.jsx("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "M9.439 9.828a1.8 1.8 0 0 1-.327-1.024c0-1.078.99-1.953 2.21-1.953h.884c1.335 0 1.769-.782 1.769-.782s.486 4.689-2.653 4.689c-.433 0-.831-.11-1.167-.297-.212.5-.522 1.375-.672 2.313 1.114.172 2.016.695 2.45 1.383 1.494-.914 2.484-2.446 2.484-4.18h2.653c0 4.094-3.767 7.423-8.4 7.423S.27 14.07.27 9.976s3.766-7.423 8.4-7.423V.6l3.536 3.125L8.67 6.851V4.897c-3.166 0-5.748 2.282-5.748 5.08 0 1.726.982 3.258 2.485 4.18.45-.72 1.441-1.266 2.635-1.407a6.6 6.6 0 0 0-.434-1.586 1.9 1.9 0 0 1-1.149.375c-.973 0-1.768-.703-1.768-1.563v-.773c0-.438-.168-.852-.443-1.18 0 0 3.935-.18 3.98 1.953 0 .227-.054.438-.15.625A5.7 5.7 0 0 0 6.9 9.977c.513.336 1.211 1.07 1.769 2.032.592-1.266 1.485-2.555 2.652-3.594q-1.008.607-1.883 1.414",
    fill: "currentColor"
  }
) });
export {
  o as F
};
